import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery.js'

/**
 * A Singleton class that handles the initial Algolia configuration.
 */
let instance = null;

export default class AlgoliaConfig
{
    constructor()
    {
        if (! instance) {
            instance = this;
            this.initialised = false;
            this.moduleLoaded = false;
        }

        return instance;
    }
    init(
        appId,
        apiKey,
        index,
        userSessionToken,
        userAccountToken,
        suggestionsIndex,
        trackingEnabled,
        trackingCookieName,
        debounceMS
    ) {
        if (!this.initialised) {
            this.initialised = true;
            this.appId = appId;
            this.apiKey = apiKey;
            this.index = index;
            this.userSessionToken = userSessionToken;
            this.userAccountToken = userAccountToken;
            this.suggestionsIndex = suggestionsIndex;
            this.trackingEnabled = trackingEnabled;
            this.trackingCookieName = trackingCookieName;
            this.debounceMS = debounceMS;
        }
    }

    getAppId()
    {
        return this.appId;
    }

    getApiKey()
    {
        return this.apiKey;
    }

    getIndex()
    {
        return this.index;
    }

    isTrackingEnabled()
    {
        return this.trackingEnabled;
    }

    getUserSessionToken()
    {
        return this.userSessionToken;
    }

    getUserAccountToken()
    {
        return this.userAccountToken;
    }

    getTrackingCookieName()
    {
        return this.trackingCookieName;
    }

    getAnalyticsTags(namespace)
    {
        const analyticsTags = [];

        if (namespace === 'prodsearchp') {
            analyticsTags.push('search');
        } else if (namespace === 'homepage') {
            analyticsTags.push('homepage');
        } else if (namespace === 'prodshow') {
            analyticsTags.push('product-details');
        } else {
            analyticsTags.push('browse');
        }

        if (MediaQuery.current === 'small') {
            analyticsTags.push('mobile');
        } else {
            analyticsTags.push('desktop');
        }

        return analyticsTags;
    }
}